/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2025 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */

import React from 'react';
import App from 'App';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { testBucketsAvailability } from 'redux/reducers/buckets';
import { fetchFairs } from 'redux/reducers/fairs';
import { fetchSoftware } from 'redux/reducers/softwares';
import { fetchUser } from 'redux/reducers/user';
import { PersistGate } from 'redux-persist/integration/react';
import { fetchMachines } from './redux/reducers/machines';
import { persistore, store } from './redux/store';
import * as serviceWorker from './serviceWorker';

store.dispatch(testBucketsAvailability);
store.dispatch(fetchMachines);
store.dispatch(fetchSoftware);
store.dispatch(fetchFairs);
store.dispatch(fetchUser);

const root = createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistore}>
      <App />
    </PersistGate>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
